// src/hooks/usePrevious.ts
import { useEffect, useRef } from "react";
function usePrevious(state) {
  const ref = useRef();
  useEffect(() => {
    ref.current = state;
  });
  return ref.current;
}
export {
  usePrevious
};
//# sourceMappingURL=usePrevious.mjs.map